export enum ManagerQueueTaskColumns {
  phase,
  task,
  patient,
  physician,
  // payer, TODO: Removing for now
  // pharmacy, TODO: Removing for now
  dueDate,
}
